import { useEffect } from "react";
import { router } from "./routes";
import { RouterProvider } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAccountDetails,
  getTransactionResourceHandler,
  getWalletDetails,
} from "./redux/accountSlice";

function App() {
  const dispatch = useDispatch();
  const { accountAddress } = useSelector((state) => state.account);

  useEffect(() => {
    const handleMessage = (res) => {
      if (res.data.message && res.data.message.action === "setAccount") {
        if (window.tronWeb) {
          if (res.data.message.data.address !== accountAddress) {
            localStorage.clear();
            window.location.reload();
          }
        }
      }
    };

    window.addEventListener("message", handleMessage);
    
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [accountAddress]);
  useEffect(() => {
    // Check wallet details immediately on mount
    dispatch(getWalletDetails());
    
    // Set up polling for wallet changes
    const interval = setInterval(() => {
      dispatch(getWalletDetails());
    }, 3000);
    
    // Listen for window focus events (when user switches back to tab after connecting wallet)
    const handleFocus = () => {
      dispatch(getWalletDetails());
    };
    
    // Listen for TronWeb ready events
    const handleTronWebReady = () => {
      setTimeout(() => {
        dispatch(getWalletDetails());
      }, 500); // Small delay to ensure TronWeb is fully initialized
    };
    
    window.addEventListener('focus', handleFocus);
    window.addEventListener('tronWeb#initialized', handleTronWebReady);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('tronWeb#initialized', handleTronWebReady);
    };
  }, [dispatch]);

  useEffect(() => {
    if (accountAddress) {
      dispatch(fetchAccountDetails());
    }
  }, [accountAddress, dispatch]);

  useEffect(() => {
    dispatch(getTransactionResourceHandler());
  }, [dispatch]);

  return <RouterProvider router={router} />;
}

export default App;
